import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import ProductForm from '../../components/products/ProductForm';
import Button from '../../components/common/Button';
import { useProductForm } from '../../hooks/useProductForm';
import { theme } from '../../config/theme';
import { ArrowLeftIcon } from '../../components/icons/Icons';

const ProductCreate = () => {
  const navigate = useNavigate();

  const {
    formData,
    images,
    existingImages,
    errors,
    touched,
    loading,
    handleChange,
    handleBlur,
    handleImageAdd,
    handleImageRemove,
    handleExistingImageRemove,
    handleTagAdd,
    handleTagRemove,
    handleSubmit,
  } = useProductForm();

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '900px', margin: '0 auto' }}>
        {/* ✅ FIXED: Properly styled back button with icon */}
        <Button 
          variant="ghost" 
          onClick={() => navigate('/seller/products')}
          style={{ marginBottom: theme.spacing.lg }}
        >
          <ArrowLeftIcon size={18} />
          Back to Products
        </Button>

        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Create New Product
        </h1>

        <ProductForm
          formData={formData}
          images={images}
          existingImages={existingImages}
          errors={errors}
          touched={touched}
          loading={loading}
          onChange={handleChange}
          onBlur={handleBlur}
          onImageAdd={handleImageAdd}
          onImageRemove={handleImageRemove}
          onExistingImageRemove={handleExistingImageRemove}
          onTagAdd={handleTagAdd}
          onTagRemove={handleTagRemove}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/seller/products')}
        />
      </div>
    </MainLayout>
  );
};

export default ProductCreate;